import EstateAccountSelectionModal from '/@/modules/estateaccount/components/EstateAccountSelectionModal.vue';
import { PredefinedEstateRole } from '/@/modules/role/enums/PredefinedEstateRole';
import { NavEvents } from '/@/modules/core/nav/constants/nav.constants';
import NumeralService from '/@/modules/core/app/services/NumeralService';
import ModalService from '/@/modules/core/ui/services/ModalService';
import AuthService from '/@/modules/auth/services/AuthService';
import Lang from '/@/modules/core/app/services/Lang';
import { Estate } from '/@/modules/estate/models/Estate';

export const ImpersonateUserModalMixin = {
  emits: ['on-impersonate-click'],
  props: {
    estate: { type: Estate }
  },
  methods: {
    onImpersonateClick() {
      this.$emit('on-impersonate-click', this.estate);
      ModalService.show({
        parent: this,
        component: EstateAccountSelectionModal,
        props: {
          title: this.$t('estate.select-user-as'),
          estateId: this.estate.id,
          roleIds: PredefinedEstateRole.getValuesByProp('id'),
          showProfession: true
        },
        events: {
          'on-submit': async (estateAccount) => {
            await AuthService.impersonateUser(
              estateAccount.userId,
              estateAccount.estateId,
              async (user) => {
                await this.$router.push({ name: user.homePage });
                ModalService.close();
                EventBus.signal(NavEvents.RELOAD);
                await Lang.resetI18n(user.locale);
                NumeralService.load(user.locale);
              }
            );
          }
        }
      });
    }
  }
};
